import React, { Component } from 'react';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { Button } from '@progress/kendo-react-buttons';
import { ComboBox } from '@progress/kendo-react-dropdowns';
import { filterBy, orderBy } from '@progress/kendo-data-query';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { DebounceInput } from 'react-debounce-input';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { getRegions} from '../../masterData/region/RegionService';
import { getCost } from '../../masterData/costCard/CostCardService';
import { getMSProjectsAndCrsByRegion, createRegionMSContract, getRegionMSContracts, createRegionResourceAllocations, 
    getAllContractsByRegion, removeRegionMSContract, getAllResourcesByRegion, removeRegionMSResource} from './ManagedServiceResourcePoolService';
import { getActiveProjectResources, getRatesForAllocation } from '../../resourceManagement/ResourceService';
import { getAllDesignations } from "../../masterData/designation/DesignationService";
import { getRateTypesIntegrated } from '../../integration/MasterDataService';
import { formatNumber } from '../../integration/CommonUtils';
import Loader from '../../integration/components/Loader';
import SuccessImg from '../../ui/static/images/checked.svg';
import ErrorImg from '../../ui/static/images/cancel.svg';
import * as loggerService from "../../integration/LoggerService";
import {LOG_TYPES} from "../../integration/IntegrationEnums";
import moment from 'moment';

const CUSTOM_RATE = 'CUSTOM_RATE';


class ManagedServiceResourcePool extends Component {
    constructor(props) {
        super(props);
        this.state = {
            contractData: [],
            resourceData: [],
            projectRegions: [],
            projectRegionsAll: [],
            selectedRegion: null,
            projectsAndCrs: [],
            projectsAndCrsAll: [],
            selectedProjectOrCr: null,
            projectStartDate: null,
            projectEndDate: null,
            disableConfirmButton: true,
            showAddContractDialog: false,
            showMessageDialog: false,
            dialogMessage: '',
            dialogTitle: '',
            newAllocationPercentage: '',
            loading: false,
            showAddResourceDialog: false,
            showRemoveContractDialog: false,
            showRemoveResourceDialog: false,
            showErrorMessage: false,
            resources: [],
            resourcesAll: [],
            selectedResource: null,
            projectRole: [],
            projectRoleAll: [],
            selectedProjectRole: null,
            designations: [],
            designationsAll: [],
            selectedDesignation: null,
            resourceRegions: [],
            resourceRegionsAll: [],
            selectedResourceRegion: null,
            regionResources: [],
            regionResourcesAll: [],
            selectedRegionResource: null,
            rateTypesAll: [],
            newRatesAll: [],
            newRate: null, 
        }
    }

    async componentDidMount() {
        this.isMount = true;
        window.scrollTo(0, 0);
        this.setHeaderTitle();
        await this.setState({
            loading: true,
        });
        await this.populateProjectRegions();
        await this.getAllActiveResources();
        await this.populateDesignations();
        await this.populateRateTypesIntegrated();
        await this.setState({
            loading: false,
        });
    }

    setHeaderTitle = async () => {
        if (this.isMount && this.props.onHeaderTitleChange) {
            this.props.onHeaderTitleChange('Managed Services Resource Center');
        }
    };

    populateProjectRegions = async () => {
        await getRegions().then(res => {
            if (this.isMount) {
                this.setState({
                    projectRegions: res.data,
                    projectRegionsAll: res.data,
                    resourceRegions: res.data,
                    resourceRegionsAll: res.data,
                });
            }
            })
            .catch(error => {
                loggerService.writeLog(error, LOG_TYPES.ERROR);
        });
    };

    getAllActiveResources = async () => {
        await getActiveProjectResources() 
            .then(async res => {
            await this.setState({
                resources: res.data,
                resourcesAll: res.data,
            });
        })
        .catch(error => {
            loggerService.writeLog(error, LOG_TYPES.ERROR);
        });
    };

    populateDesignations = async () => {
        await getAllDesignations()
            .then(res => {
            if (this.isMount) {
                const roles = res.data.filter(obj => obj.Name !== "Outsourced");
                this.setState({
                    designations: roles,
                    designationsAll: roles,
                    projectRole: roles,
                    projectRoleAll: roles,
                });
            }
            })
            .catch(error => {
                loggerService.writeLog(error, LOG_TYPES.ERROR);
            });
    };

    populateRateTypesIntegrated = async () => {
        await getRateTypesIntegrated().then(resRT => {
            let rateTypes = [];
            if (resRT.data && resRT.data.length > 0) {
                for (const rateType of resRT.data) {
                    if (rateType.Code !== CUSTOM_RATE) {
                        rateType.Rate = 0;
                        rateType.name = rateType.Name + ' - 0.00';
                    } else {
                        rateType.name = rateType.Name;
                    }
                    rateTypes.push(rateType);
                }
            }
            this.setState({
                rateTypesAll: rateTypes,
            });
        })
        .catch(error => {
            loggerService.writeLog(error, LOG_TYPES.ERROR);
        });
    };
    

    submitSearch = async() => {
        await this.setState({
            loading: true,
        });

        const fields = {
            SelectedRegion: this.state.selectedRegion ? this.state.selectedRegion.id  : null
        };        
        await getRegionMSContracts(fields)
            .then(res => {
                if (this.isMount) {
                    this.setState({
                        contractData: res.data.ContractData,
                        resourceData: res.data.ResourceData,
                    });
                }
            })
            .catch(error => {
                loggerService.writeLog(error, LOG_TYPES.ERROR);
            });

        await this.setState({
            loading: false,
        });

    };

    onClickCancel = async() => {
        await this.setState({
            selectedRegion: null,
        });
    };

    handleInputChange = event => {
        const valueObj = event.target.value;
        const field = event.target.name;
        if (this.isMount) {
            this.setState({
                [field]: valueObj
            });
        }
    };

    handleProjectRoleChange = async (event) => {
        const value = event.target.value;
        const field = event.target.name;
        let designations = [];
        let selectedDesignation = null;
        if (value) {
          await this.getAllocationRates(value);
          let filteredArray = this.state.designationsAll.filter(function (itm) {
            return value.CategoryId === itm.CategoryId;
          });
          designations = filteredArray;

          let desig = this.state.designationsAll.filter(function (itm) {
            return value.id === itm.id;
          });
          selectedDesignation = desig[0];
        }

        this.setState({
            [field]: value,
            designations: designations,
            selectedDesignation: selectedDesignation
        });
    };

    handleRateTypeChange = event => {
        const valueObj = event.target.value;
        const field = event.target.name;
        if (this.isMount) {
            this.setState({
                [field]: valueObj
            });
        }
        const dataItem = valueObj;
        if (dataItem) {
            dataItem.RateValueDisabled = true;
            dataItem.RateValue = dataItem.Rate ? dataItem.Rate : 0;
            dataItem.LastCustomerRateProject = '';

            if (dataItem.Code === CUSTOM_RATE) {
                dataItem.RateValueDisabled = false;
                dataItem.RateValue = 0;
                dataItem.Rate = 0;
            }
            if (!dataItem.RateValue) {
                dataItem.RateValue = 0;
                dataItem.Rate = 0;
            }
        }
    };

    handleRateValueChange = event => {
        let value = event.target.value;
        if (value < 0) {
            value = 0;
        }
        let newRate = this.state.newRate;
        newRate.Rate = Number((Number(value)).toFixed(2));
        this.setState({
            newRate: newRate,
        });
    };

    getAllocationRates = async (role) => {

        let customerRate, regionRate,  projectRate,projectCrRate,lastCustomRate, lastApprovedProject_Rate = 0;
        let lastCustomRateProjectName = '';

        let roleName = role.Name;
        let rateCardParams = {
            customerId: null,
            regionId: this.state.selectedRegion ? this.state.selectedRegion.id : null,
            role: role.id,
            projectDate: new Date(),
            dataType: null,
            projectId: null
        };

        await getRatesForAllocation(rateCardParams)
            .then(async result => {
                const defaultRate = result.data.defaultRate;
                const customersRate = result.data.customerRate;
                const lastCustomerRate = result.data.lastCustomerRate;
                const lastApprovedProjRate = result.data.lastApprovedrate;
                const customRate = result.data.customRate;
                const projectSpecificRate = result.data.projectSpecificRate;
                const projectSpecificCrRate = result.data.projectSpecificCrRate;
                
                //For standard rate
                if (defaultRate && defaultRate.Rate > 0) {
                    regionRate = defaultRate.Rate > 0 ? defaultRate.Rate : 0;
                }
                //For pre-agreed rate
                if (customersRate && customersRate.Rate > 0) {
                    customerRate = customersRate.Rate > 0 ? customersRate.Rate : 0;
                }
                //For last overridden rate
                if (lastCustomerRate && lastCustomerRate.Rate > 0) {
                    lastCustomRate = lastCustomerRate.Rate;
                    lastCustomRateProjectName = lastCustomerRate.Project.Name;
                }
        
                //For project specific rate
                if (projectSpecificRate && projectSpecificRate.Rate > 0) {
                    projectRate = projectSpecificRate.Rate > 0 ? projectSpecificRate.Rate : 0;
                }
                //For project specific CR rate
                if (projectSpecificCrRate && projectSpecificCrRate.Rate > 0) {
                    projectCrRate = projectSpecificCrRate.Rate > 0 ? projectSpecificCrRate.Rate : 0;
                }
        
                //For overridden rate
                if (lastApprovedProjRate && lastApprovedProjRate.Rate > 0) {
                    lastApprovedProject_Rate = lastApprovedProjRate.Rate;
                }
            
                if (!customersRate || (customersRate.Rate && customersRate.Rate <= 0)) {
                    if ((!regionRate || (regionRate.Rate && regionRate.Rate <= 0))) {
                    this.setState({
                        showSuccessImage: false,
                        showErrorImage: true,
                    });
                    const message = 'Standard rate not found for ' + roleName;
                    const title = 'Error';
                    this.toggleMessageDialog(message, title);
                    }
                }
                let tmpRates = this.state.rateTypesAll;
                for (let rateType of tmpRates) {
                    if (rateType.Code === 'CUSTOMER_RATE') {
                        rateType.Rate = customerRate;
                        rateType.name = rateType.Name + ' - ' + formatNumber(rateType.Rate);
                    }
                    if (rateType.Code === 'REGION_RATE') {
                        rateType.Rate = regionRate;
                        rateType.name = rateType.Name + ' - ' + formatNumber(rateType.Rate);
                    }
                    if (rateType.Code === 'LAST_CUS_RATE') {
                        rateType.Rate = lastCustomRate;
                        rateType.name = rateType.Name + ' - ' + formatNumber(rateType.Rate);
                        rateType.LastCustomerRateProject = lastCustomRateProjectName;
                    }
                    if (rateType.Code === 'APPROVED_PROJ_RATE') {
                        rateType.Rate = lastApprovedProject_Rate;
                        rateType.name = rateType.Name + ' - ' + formatNumber(rateType.Rate);
                    }
                    if (rateType.Code === 'PROJECT_APPROVED_RATE') {
                        rateType.Rate = projectRate;
                        rateType.name = rateType.Name + ' - ' + formatNumber(rateType.Rate);
                    }
                    if (rateType.Code === 'PROJECT_APPROVED_CR_RATE') {
                        rateType.Rate = projectCrRate;
                        rateType.name = rateType.Name + ' - ' + formatNumber(rateType.Rate);
                    }
                    if (rateType.Code === 'CUSTOM_RATE') {
                        rateType.Rate = Number(customRate);
                        rateType.name = rateType.Name + ' - ' + formatNumber(rateType.Rate);
                    }
                }            
            })
            .catch(error => {
                loggerService.writeLog(error, LOG_TYPES.ERROR);
            });
      };
    

    handleProjectOrCrChange = event => {
        const valueObj = event.target.value;
        const field = event.target.name;
        if (this.isMount) {
            this.setState({
                [field]: valueObj
            });
        }
        if (valueObj) {
            const startDate = valueObj.StartDate ? new Date(valueObj.StartDate) : null;
            const endDate = valueObj.ProjectEndDate ? new Date(valueObj.ProjectEndDate) : null;
            this.setState({
                projectStartDate: startDate,
                projectEndDate: endDate,
            });
        } else {
            this.setState({
                projectStartDate: null,
                projectEndDate: null,
            });
        }
    };

    onClickAddContract = async() => {
        if (!this.state.selectedRegion) {
            this.setState({
                showSuccessImage: false,
                showErrorImage: true,
            });
            const message = 'Select a Region to add a contract.';
            const title = 'Error';
            this.toggleMessageDialog(message, title);
        } else {
            const fields = {
                SelectedRegion: this.state.selectedRegion ? this.state.selectedRegion.id  : null
            };        
            await getMSProjectsAndCrsByRegion(fields)
                .then(res => {
                    if (this.isMount) {
                        this.setState({
                            projectsAndCrs: res.data,
                            projectsAndCrsAll: res.data,
                        });
                    }
                })
                .catch(error => {
                    loggerService.writeLog(error, LOG_TYPES.ERROR);
                });

            this.toggleDialogAddContract()
        }
    }

    onClickRemoveContract = async() => {
        if (!this.state.selectedRegion) {
            this.setState({
                showSuccessImage: false,
                showErrorImage: true,
            });
            const message = 'Select a Region to remove a contract.';
            const title = 'Error';
            this.toggleMessageDialog(message, title);
        } else {
            const fields = {
                SelectedRegion: this.state.selectedRegion ? this.state.selectedRegion.id  : null
            };        
            await getAllContractsByRegion(fields)
                .then(res => {
                    if (this.isMount) {
                        this.setState({
                            projectsAndCrs: res.data,
                            projectsAndCrsAll: res.data,
                        });
                    }
                })
                .catch(error => {
                    loggerService.writeLog(error, LOG_TYPES.ERROR);
                });

            this.toggleDialogRemoveContract()
        }
    }

    onClickAddResource = async() => {
        if (!this.state.selectedRegion) {
            this.setState({
                showSuccessImage: false,
                showErrorImage: true,
            });
            const message = 'Select a Region to add a resource.';
            const title = 'Error';
            this.toggleMessageDialog(message, title);
        } else {
            this.setState({
                designations: this.state.designationsAll,
                projectRole: this.state.projectRoleAll,
                resources: this.state.resourcesAll
            });
            this.toggleDialogAddResource()
        }
    }


    onClickRemoveResource = async() => {
        if (!this.state.selectedRegion) {
            this.setState({
                showSuccessImage: false,
                showErrorImage: true,
            });
            const message = 'Select a Region to remove a resource.';
            const title = 'Error';
            this.toggleMessageDialog(message, title);
        } else {
            const fields = {
                SelectedRegion: this.state.selectedRegion ? this.state.selectedRegion.id  : null
            };        
            await getAllResourcesByRegion(fields)
                .then(res => {
                    if (this.isMount) {
                        this.setState({
                            regionResources: res.data,
                            regionResourcesAll: res.data,
                        });
                    }
                })
                .catch(error => {
                    loggerService.writeLog(error, LOG_TYPES.ERROR);
                });

            this.toggleDialogRemoveResource()
        }
    }

    toggleMessageDialog = (message, title) => {
        this.setState({
            showMessageDialog: !this.state.showMessageDialog,
            dialogMessage: message,
            dialogTitle: title
        });
    };

    toggleDialogAddContract = async () => {
        await this.setState({
            disableConfirmButton: true,
            selectedProjectOrCr: null,
            newAllocationPercentage: '',
            showErrorMessage: false,
            showAddContractDialog: !this.state.showAddContractDialog,
        });  
    }

    toggleDialogRemoveContract = async () => {
        await this.setState({
            disableConfirmButton: true,
            selectedProjectOrCr: null,
            newAllocationPercentage: '',
            showErrorMessage: false,
            showRemoveContractDialog: !this.state.showRemoveContractDialog,
        });  
    }

    toggleDialogRemoveResource = async () => {
        await this.setState({
            selectedRegionResource: null,
            showErrorMessage: false,
            showRemoveResourceDialog: !this.state.showRemoveResourceDialog,
        });  
    }

    toggleDialogAddResource = async () => {
        await this.setState({
            disableConfirmButton: true,
            selectedResource: null,
            selectedProjectRole: null,
            selectedDesignation: null,
            selectedRegionResource: null,
            newAllocationPercentage: '',
            newRate: null,
            showErrorMessage: false,
            showAddResourceDialog: !this.state.showAddResourceDialog,
        });  
    }

    filterProjectRegions = event => {
        if (this.isMount) {
            this.setState({
                projectRegions: this.filterData(event.filter, this.state.projectRegionsAll)
            });
        }
    };

    filterProjectsAndCrs = event => {
        if (this.isMount) {
            this.setState({
                projectsAndCrs: this.filterData(event.filter, this.state.projectsAndCrsAll)
            });
        }
    };

    filterResources = event => {
        if (this.isMount) {
        this.setState({
            resources: this.filterData(event.filter, this.state.resourcesAll)
        });
        }
    };

    filterProjectRoles = event => {
        if (this.isMount) {
            this.setState({
                projectRole: this.filterData(event.filter, this.state.projectRoleAll)
            });
        }
    };

    filterDesignations = event => {
        if (this.isMount) {
            this.setState({
                designations: this.filterData(event.filter, this.state.designationsAll)
            });
        }
    };

    filterResourceRegions = event => {
        if (this.isMount) {
            this.setState({
                resourceRegions: this.filterData(event.filter, this.state.resourceRegionsAll)
            });
        }
    };

    filterRegionResources = event => {
        if (this.isMount) {
        this.setState({
            regionResources: this.filterData(event.filter, this.state.regionResourcesAll)
        });
        }
    };

    filterData(filter, allData) {
        const data = allData.slice();
        return filterBy(data, filter);
    }

    validateProperty = value => {
        if (value) {
            return 'd-none';
        } else {
            return 'inline-error';
        }
    };

    validateNumber = value => {
        if (value) {
            if (value > 0) {
                return 'd-none';
            }
        return 'inline-error';
        } else {
            return 'inline-error';
        }
    };

    handleAllocationPercentageChange = async event => {
        let value = event.target.value;
        if (value < 0) {
            value = 0;
        } else if (value > 100) {
            value = 100;
        }
        await this.setState({
            newAllocationPercentage: Number((Number(value)).toFixed(2))
        });
        if (this.state.newAllocationPercentage) {
            await this.setState({
                disableConfirmButton: false
        });
        } else {
            await this.setState({
                disableConfirmButton: true
            });
        }
    };

    confirmAddContract = async () => {
        await this.setState({
            disableConfirmButton: true,
            loading: true
        });

        if (!this.state.selectedProjectOrCr || !this.state.newAllocationPercentage) {
            await this.setState({
                showErrorMessage: true,
                disableConfirmButton: false,
                loading: false
            });
            return;
        }

        const fields = {
            RegionId: this.state.selectedRegion ? this.state.selectedRegion.id  : null,
            ProjectId: this.state.selectedProjectOrCr && this.state.selectedProjectOrCr.ProjectType === "ChangeRequest" ? this.state.selectedProjectOrCr.ProjectId  : this.state.selectedProjectOrCr.id,
            CrId: this.state.selectedProjectOrCr && this.state.selectedProjectOrCr.ProjectType === "ChangeRequest" ? this.state.selectedProjectOrCr.id  : null,
            UniqueId: this.state.selectedProjectOrCr ? this.state.selectedProjectOrCr.UniqueId  : null,
            NewAllocationPercentage: this.state.newAllocationPercentage
        };
        await createRegionMSContract(fields)
            .then(async res => {
                await this.toggleDialogAddContract();
                await this.submitSearch();
                if (this.isMount) {
                    this.setState({
                        loading: false
                    });
                }
            })
            .catch(error => {
                loggerService.writeLog(error, LOG_TYPES.ERROR);
            });

        await this.setState({
            loading: false
        });
    }

    confirmRemoveContract = async () => {
        await this.setState({
            disableConfirmButton: true,
            loading: true
        });

        if (!this.state.selectedProjectOrCr || !this.state.newAllocationPercentage) {
            await this.setState({
                showErrorMessage: true,
                disableConfirmButton: false,
                loading: false
            });
            return;
        }

        const fields = {
            RegionId: this.state.selectedRegion ? this.state.selectedRegion.id  : null,
            ContractId: this.state.selectedProjectOrCr ? this.state.selectedProjectOrCr.id  : null,
            UniqueId: this.state.selectedProjectOrCr ? this.state.selectedProjectOrCr.UniqueId  : null,
            DeallocateDate: moment(new Date()).format('YYYY-MM-DD'),
            NewAllocationPercentage: this.state.newAllocationPercentage
        };
        await removeRegionMSContract(fields)
            .then(async res => {
                await this.toggleDialogRemoveContract();
                await this.submitSearch();
                if (this.isMount) {
                    this.setState({
                        loading: false
                    });
                }
            })
            .catch(error => {
                loggerService.writeLog(error, LOG_TYPES.ERROR);
            });

        await this.setState({
            loading: false
        });
    }

    confirmAddResource = async () => {
        await this.setState({
            loading: true
        });
        if (!this.validateAddingValues()) {
            this.setState({
                showErrorMessage: true,
                disableConfirmButton: false,
                loading: false
            });
            return;
        }
        const costValidation = await this.validateCostCard();  //cost card validation
        if (!costValidation) {
            this.setState({
                showSuccessImage: false,
                showErrorImage: true,
            });
            const message = "Cost card record not found for the selected resource's designation and region.";
            const title = 'Error';
            this.toggleMessageDialog(message, title);
        } else {
            const fields = {
                Region: this.state.selectedRegion ? this.state.selectedRegion  : null,
                Resource: this.state.selectedResource ? this.state.selectedResource  : null,
                Allocation: this.state.newAllocationPercentage,
                ProjectRole: this.state.selectedProjectRole ? this.state.selectedProjectRole.id : null,
                Designation: this.state.selectedDesignation ? this.state.selectedDesignation.id : null,
                RateType: this.state.newRate ? this.state.newRate.id : null,
                RateValue: this.state.newRate ? this.state.newRate.Rate : null,
                ProjectRoleName: this.state.selectedProjectRole ? this.state.selectedProjectRole.Name : null,
            };        
            await createRegionResourceAllocations(fields)
                .then(async res => {
                    await this.toggleDialogAddResource();
                    await this.submitSearch();
                    if (this.isMount) {
                        this.setState({
                            loading: false
                        });
                    }
                })
                .catch(error => {
                    this.setState({
                        showSuccessImage: false,
                        showErrorImage: true,
                    });
                    const message = error.response.data;
                    const title = 'Error';
                    this.toggleMessageDialog(message, title);
                    loggerService.writeLog(error, LOG_TYPES.ERROR);
                });
        }
        await this.setState({
            loading: false,
            showErrorMessage: false,
        });
    }

    validateCostCard = async () => {
        let costDate_ = new Date();
        const costCard = {
            billingRegionId: this.state.selectedRegion ? this.state.selectedRegion.id : null,
            resourceRegionId: this.state.selectedResource ? this.state.selectedResource.Region : null,
            designationId: this.state.selectedResource ? this.state.selectedResource.DesignationId : null,
            projectId: null,
            costDate: moment(costDate_).format('YYYY-MM-DD')
        };        
        try {
            const res = await getCost(costCard);            
            if (res.data.length > 0 && res.data[0].id > 0) {
                const costCard = res.data[0];
                const costRecord = {
                    CurrencyId: costCard.BillingRegion.Currency.id,
                    Overhead: costCard.CostCardDesignations[0].Overhead,
                    CostToCompany: costCard.CostCardDesignations[0].CostToCompany
                };
                let costPerResourceTotal = costRecord.Overhead + costRecord.CostToCompany;
                
                return costPerResourceTotal !== 0;
            } else {
                // Fallback to previous financial year
                let costDate = costDate_;
                const costYear = new Date(costDate_).getFullYear();
                const costMonth = new Date(costDate_).getMonth() + 1;
                
                if (costMonth == 1 || costMonth == 2 || costMonth == 3) { 
                    // check if the month is Jan/Feb/March
                    let prevYear = (costYear - 1).toString();
                    costDate = prevYear + '-03-31';
                } else {
                    costDate = costYear + '-03-31';
                }
                
                costCard.costDate = moment(costDate).format("YYYY-MM-DD");                
                try {
                    const res2 = await getCost(costCard);                    
                    if (res2.data.length > 0 && res2.data[0].id > 0) {
                        const costCard2 = res2.data[0];
                        const costRecord2 = {
                            CurrencyId: costCard2.BillingRegion.Currency.id,
                            Overhead: costCard2.CostCardDesignations[0].Overhead,
                            CostToCompany: costCard2.CostCardDesignations[0].CostToCompany
                        };
                        let costPerResourceTotal2 = costRecord2.Overhead + costRecord2.CostToCompany;
                        
                        return costPerResourceTotal2 !== 0;
                    } else {
                        return false;
                    }
                } catch (error) {
                    loggerService.writeLog(error, LOG_TYPES.ERROR);
                    return false; // Return false on error
                }
            }
        } catch (error) {
            loggerService.writeLog(error, LOG_TYPES.ERROR);
            return false; // Return false on error
        }
    };

    validateAddingValues = () => {
        if (
        this.validateProperty(this.state.selectedRegion)
            .toString()
            .includes('error')
        ) {
            return false;
        } else if (
        this.validateProperty(this.state.selectedResource)
            .toString()
            .includes('error')
        ) {
            return false;
        } else if (
        this.validateProperty(this.state.selectedProjectRole)
            .toString()
            .includes('error')
        ) {
            return false;
        } else if (
        this.validateProperty(this.state.selectedDesignation)
            .toString()
            .includes('error')
        ) {
            return false;
        } else if (
        this.validateNumber(this.state.newAllocationPercentage)
            .toString()
            .includes('error')
        ) {
            return false;
        } else if (
        this.validateProperty(this.state.newRate)
            .toString()
            .includes('error')
        ) {
            return false;
        } else {
            return true;
        }
    };

    confirmRemoveResource = async () => {
        await this.setState({
            loading: true
        });
        if (!this.state.selectedRegionResource) {
            await this.setState({
                showErrorMessage: true,
                disableConfirmButton: false,
                loading: false
            });
            return;
        }
        const fields = {
            Region: this.state.selectedRegion ? this.state.selectedRegion  : null,
            Resource: this.state.selectedRegionResource ? this.state.selectedRegionResource  : null,
            DeallocateDate: moment(new Date()).format('YYYY-MM-DD')
        };        
        await removeRegionMSResource(fields)
            .then(async res => {
                await this.toggleDialogRemoveResource();
                await this.submitSearch();
                if (this.isMount) {
                    this.setState({
                        loading: false
                    });
                }
            })
            .catch(error => {
                loggerService.writeLog(error, LOG_TYPES.ERROR);
            });
        await this.setState({
            loading: false
        });
    }

    customCell = (props, resource) => {
        if (resource.Allocation) {
            return <td style={{ textAlign: 'center' }}>{resource.Allocation + '%'}</td>;
        } else {
            return <td style={{ textAlign: 'center' }}>{0 + '%'}</td>;
        }
    }

    setAllocationTotal = (resource) => {
        if (resource.TotalAllocation) {
            return <div style={{ textAlign: 'center' }}>{resource.TotalAllocation + '%'}</div>;
        } else {
            return <div style={{ textAlign: 'center' }}>{0 + '%'}</div>;
        }
    }

    render() {
        return (
            <div className="main-card">
                <div className="row">
                    <div className="col-md-9">
                        <div className="main-heading">Managed Services Resource Center</div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-4">
                        <div className="d-block">
                            <label>Region:</label>
                        </div>
                        <div>
                            <ComboBox
                                placeholder="Please Select"
                                data={this.state.projectRegions}
                                value={this.state.selectedRegion}
                                textField="Name"
                                dataItemKey="id"
                                onChange={this.handleInputChange}
                                name="selectedRegion"
                                filterable={true}
                                onFilterChange={this.filterProjectRegions}
                            />
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12" style={{ textAlign: 'right' }}>
                        <Button type="button" onClick={this.onClickCancel} style={{ marginRight: '5px' }}>
                            Clear
                        </Button>
                        <Button primary={true} type="submit" onClick={this.submitSearch}>
                            Search
                        </Button>
                    </div>
                </div>

                <div className="main-seperator"></div>

                <div className="row">
                    <div className="col-md-12">
                        <div className="main-heading">Search Results</div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12" style={{ textAlign: 'right', marginBottom: '10px' }}>
                        <Button primary={true} type="button" onClick={this.onClickAddContract} style={{ marginRight: '5px' }}>
                            Add Contract
                        </Button>
                        <Button primary={true} type="button" onClick={this.onClickAddResource} style={{ marginRight: '5px' }}>
                            Add Resource
                        </Button>
                        <Button primary={true} type="button" onClick={this.onClickRemoveContract} style={{ marginRight: '5px' }}>
                            Remove Contract
                        </Button>
                        <Button primary={true} type="button" onClick={this.onClickRemoveResource}>
                            Remove Resource
                        </Button>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12 ms-pool-grid">
                        <Grid
                            data={this.state.contractData}
                            style={this.state.contractData && this.state.contractData.length > 10 ? { height: '500px' } : ''}
                            scrollable="scrollable"
                            sortable={true}
                            resizable={true}
                        >
                            <GridColumn 
                                field="ContractName" 
                                title="Contract Name" 
                                width="200px"
                                locked={true}
                                footerCell={() => {
                                    return <td style={{ position: 'sticky', left: 0, backgroundColor: '#fff', zIndex: 1 }}>
                                        <div>Total Allocation</div>
                                    </td>;
                                }}
                            />
                            <GridColumn 
                                field="ContractStartDate" 
                                title="Contract Start Date" 
                                width="120px"
                                locked={true}
                                footerCell={() => {
                                    return <td style={{ position: 'sticky', left: "200px", backgroundColor: '#fff', zIndex: 1 }}>
                                        <div>{}</div>
                                    </td>;
                                }}
                            />
                            <GridColumn 
                                field="ContractEndDate" 
                                title="Contract End Date" 
                                width="120px"
                                locked={true}
                                footerCell={() => {
                                    return <td style={{ position: 'sticky', left: "320px", backgroundColor: '#fff', zIndex: 1 }}>
                                        <div>{}</div>
                                    </td>;
                                }}
                            />
                            {this.state.resourceData.map(resource => (
                                <GridColumn
                                    key={resource.id}
                                    field={''}
                                    title={resource.Resource.Name}
                                    width="150px"
                                    headerClassName="k-resource-header"
                                    cell={props => this.customCell(props, resource)}
                                    footerCell={() =>          
                                        <td>
                                            <div>{this.setAllocationTotal(resource)}</div>
                                        </td>
                                    }
                                />
                            ))}
                        </Grid>
                    </div>
                </div>

                {this.state.showAddContractDialog === true && (
                    <Dialog title="Enter New Contract" onClose={this.toggleDialogAddContract} width="400px">
                        <div className="d-flex flex-col justify-content-start" style={{margin: '15px'}}>
                            <div className="d-block col-md-4">
                            <label>Contract:</label>
                            </div>

                            <div className="d-block">
                            <div>
                                <ComboBox
                                    data={this.state.projectsAndCrs}
                                    name="selectedProjectOrCr"
                                    textField="DisplayName"
                                    placeholder={'Please Select'}
                                    onChange={this.handleProjectOrCrChange}
                                    value={this.state.selectedProjectOrCr}
                                    filterable={true}
                                    onFilterChange={this.filterProjectsAndCrs}
                                />
                                {this.state.showErrorMessage === true ? (
                                    <span className={this.validateProperty(this.state.selectedProjectOrCr)}>
                                        Please select a contract
                                    </span>
                                ) : null}
                            </div>
                            </div>
                        </div>

                        <div className="d-flex flex-col justify-content-start" style={{margin: '15px'}}>
                            <div className="d-block  col-md-4">
                                <label>New Allocation (%):</label>
                            </div>

                            <div className="d-block">
                                <div>
                                <DebounceInput
                                    debounceTimeout={2000}
                                    width="100"
                                    onChange={this.handleAllocationPercentageChange}
                                    value={this.state.newAllocationPercentage}
                                    name="newAllocationPercentage"
                                    type="number"
                                    className="k-textbox"
                                    required={true}
                                />
                                </div>
                            </div>
                        </div>

                        <div className="d-flex flex-col justify-content-start" style={{margin: '15px'}}>
                            <div className="d-block  col-md-4">
                                <label>Start Date:</label>
                            </div>

                            <div className="d-block">
                                <div>
                                <DatePicker
                                    width="100"
                                    name="projectStartDate"
                                    value={this.state.projectStartDate}
                                    format="MM/dd/yyyy"
                                    formatPlaceholder={{year: 'YYYY', month: 'MM', day: 'DD'}}
                                    disabled={true}
                                />
                                </div>
                            </div>
                        </div>

                        <div className="d-flex flex-col justify-content-start" style={{margin: '15px'}}>
                            <div className="d-block col-md-4">
                                <label>End Date:</label>
                                </div>

                                <div className="d-block">
                                <div>
                                    <DatePicker
                                        width="100"
                                        name="projectEndDate"
                                        value={this.state.projectEndDate}
                                        format="MM/dd/yyyy"
                                        formatPlaceholder={{year: 'YYYY', month: 'MM', day: 'DD'}}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </div>

                        <DialogActionsBar>
                            <button className="k-button" onClick={this.toggleDialogAddContract}>
                                Cancel
                            </button>

                            <button className="k-button modal-primary" disabled={this.state.disableConfirmButton} onClick={this.confirmAddContract}>
                                Confirm
                            </button>
                        </DialogActionsBar>
                    </Dialog>
                    )}

                    {this.state.showAddResourceDialog === true && (
                        <Dialog title={'Add Resource'} onClose={this.toggleDialogAddResource} width={750}>
            
                        <div className="row">
            
                            <div className="col-md-4">
                            <div className="">
                                <div className="d-block"><label className="mandatory">Resource:</label></div>
                                <div className="d-block">
                                <ComboBox  
                                    data={this.state.resources}
                                    name="selectedResource"
                                    textField="Name"
                                    placeholder={'Please Select'}
                                    onChange={this.handleInputChange}
                                    value={this.state.selectedResource}
                                    filterable={true}
                                    onFilterChange={this.filterResources}
                                />
                                {this.state.showErrorMessage === true ? (
                                    <span className={this.validateProperty(this.state.selectedResource)}>
                                        Please select a Resource
                                    </span>
                                ) : null}
                                </div>
                            </div>
                            </div>
                        
                            <div className="col-md-4">
                            <div className="">
                                <div className="d-block"><label className="mandatory">Project Role:</label></div>
                                <div className="d-block">
                                <ComboBox  
                                    data={this.state.projectRole}
                                    name="selectedProjectRole"
                                    textField="Name"
                                    placeholder={'Please Select'}
                                    onChange={this.handleProjectRoleChange}
                                    value={this.state.selectedProjectRole}
                                    filterable={true}
                                    onFilterChange={this.filterProjectRoles}
                                />
                                {this.state.showErrorMessage === true ? (
                                    <span className={this.validateProperty(this.state.selectedProjectRole)}>
                                        Please select a valid Role
                                    </span>
                                ) : null}
                                </div>
                            </div>
                            </div>
            
                            <div className="col-md-4">
                            <div className="">
                                <div className="d-block"><label className="mandatory">Designation:</label></div>
                                <div className="d-block">
                                <ComboBox  
                                    data={this.state.designations}
                                    name="selectedDesignation"
                                    textField="Name"
                                    placeholder={'Please Select'}
                                    onChange={this.handleInputChange}
                                    value={this.state.selectedDesignation}
                                    filterable={true}
                                    onFilterChange={this.filterDesignations}
                                />

                                {this.state.showErrorMessage === true ? (
                                    <span className={this.validateProperty(this.state.selectedDesignation)}>
                                        Please select a valid Designation
                                    </span>
                                ) : null}
                                </div>
                            </div>
                            </div>
                            </div>
            
                        <div className="row">
                                
                            <div className="col-md-4">
                            <div className="">
                                <div className="d-block"><label className="mandatory">Rate Type:</label></div>
                                <div className="d-block">
                                <ComboBox
                                    placeholder="Please select"
                                    name="newRate"
                                    data={this.state.rateTypesAll}
                                    textField="name"
                                    dataItemKey="Code"
                                    value={this.state.newRate}
                                    onChange={this.handleRateTypeChange}
                                    required={true}
                                />
                                {this.state.showErrorMessage === true ? (
                                    <span className={this.validateProperty(this.state.newRate)}>
                                        Please select a valid Rate Type
                                    </span>
                                ) : null}
                                </div>
                            </div>
                            </div>
            
                            <div className="col-md-4">
                            <div className="">
                                <div className="d-block"><label className="mandatory">Daily Rate Value:</label></div>
                                <div className="d-block">
                                <DebounceInput
                                    debounceTimeout={2000}
                                    width="100%"
                                    onChange={this.handleRateValueChange}
                                    value={this.state.newRate &&  this.state.newRate.Rate != null ? this.state.newRate.Rate : 0 }
                                    name="newRateValue"
                                    type="number"
                                    className="k-textbox"
                                    required={true}
                                    minValue={0}
                                    disabled={this.state.newRate ? this.state.newRate.RateValueDisabled : true}
                                />
                                {this.state.showErrorMessage === true && this.state.newRate && this.state.newRate.id === 4 ? (
                                    <span className={this.validateNumber(this.state.newRate.Rate)}>
                                        Please select a valid Rate Value
                                    </span>
                                ) : null}
                                </div>
                            </div>
                            </div>                                
            
                            <div className="col-md-4">
                            <div className="">
                                <div className="d-block"><label className="mandatory">Allocation (%):</label></div>
                                <div className="d-block">
                                <DebounceInput
                                    debounceTimeout={2000}
                                    width="100%"
                                    onChange={this.handleAllocationPercentageChange}
                                    value={this.state.newAllocationPercentage}
                                    name="newAllocationPercentage"
                                    type="number"
                                    className="k-textbox"
                                    required={true}
                                />
                                {this.state.showErrorMessage === true ? (
                                    <span className={this.validateNumber(this.state.newAllocationPercentage)}>
                                        Please select a valid Value
                                    </span>
                                ) : null}
                                </div>
                            </div>
                            </div>
            
                        </div>
            
                        <DialogActionsBar>
                            <button className="k-button" onClick={this.toggleDialogAddResource}>Cancel</button>
                            <button className="k-button modal-primary" disabled={this.state.disableConfirmButton} onClick={this.confirmAddResource}>Save</button>
                        </DialogActionsBar>
                        </Dialog>
                    )}

                    {this.state.showRemoveContractDialog === true && (
                        <Dialog title="Remove Contract" onClose={this.toggleDialogRemoveContract} width="400px">
                            <div className="d-flex flex-col justify-content-start" style={{margin: '15px'}}>
                                <div className="d-block col-md-4">
                                    <label>Contract:</label>
                                </div>

                                <div className="d-block">
                                <div>
                                    <ComboBox
                                        data={this.state.projectsAndCrs}
                                        name="selectedProjectOrCr"
                                        textField="DisplayName"
                                        placeholder={'Please Select'}
                                        onChange={this.handleProjectOrCrChange}
                                        value={this.state.selectedProjectOrCr}
                                        filterable={true}
                                        onFilterChange={this.filterProjectsAndCrs}
                                    />
                                    {this.state.showErrorMessage === true ? (
                                        <span className={this.validateProperty(this.state.selectedProjectOrCr)}>
                                            Please select a contract
                                        </span>
                                    ) : null}
                                </div>
                                </div>
                            </div>

                            <div className="d-flex flex-col justify-content-start" style={{margin: '15px'}}>
                                <div className="d-block  col-md-4">
                                    <label>New Allocation (%):</label>
                                </div>

                                <div className="d-block">
                                    <div>
                                    <DebounceInput
                                        debounceTimeout={2000}
                                        width="100"
                                        onChange={this.handleAllocationPercentageChange}
                                        value={this.state.newAllocationPercentage}
                                        name="newAllocationPercentage"
                                        type="number"
                                        className="k-textbox"
                                        required={true}
                                    />
                                    </div>
                                </div>
                            </div>

                            <DialogActionsBar>
                                <button className="k-button" onClick={this.toggleDialogRemoveContract}>
                                    Cancel
                                </button>

                                <button className="k-button modal-primary" disabled={this.state.disableConfirmButton} onClick={this.confirmRemoveContract}>
                                    Confirm
                                </button>
                            </DialogActionsBar>
                        </Dialog>
                    )}

                    {this.state.showRemoveResourceDialog === true && (
                        <Dialog title="Remove Resource" onClose={this.toggleDialogRemoveResource} width="400px">
                            <div className="d-flex flex-col justify-content-start" style={{margin: '15px'}}>
                                <div className="d-block col-md-4">
                                    <label>Resource:</label>
                                </div>

                                <div className="d-block">
                                <div>
                                    <ComboBox
                                        data={this.state.regionResources}
                                        name="selectedRegionResource"
                                        textField="Name"
                                        placeholder={'Please Select'}
                                        onChange={this.handleInputChange}
                                        value={this.state.selectedRegionResource}
                                        filterable={true}
                                        onFilterChange={this.filterRegionResources}
                                    />
                                    {this.state.showErrorMessage === true ? (
                                        <span className={this.validateProperty(this.state.selectedRegionResource)}>
                                            Please select a Resource
                                        </span>
                                    ) : null}
                                </div>
                                </div>
                            </div>

                            <div>
                                <p style={{ margin: '25px', textAlign: 'justify' }}>
                                    By deallocation, you will be removing the allocated resource from the region. 
                                    You will no longer be able to use this resource for further work. Are you sure you want to remove this?
                                </p>
                            </div>

                            <DialogActionsBar>
                                <button className="k-button" onClick={this.toggleDialogRemoveResource}>
                                    Cancel
                                </button>

                                <button className="k-button modal-primary" onClick={this.confirmRemoveResource}>
                                    Confirm
                                </button>
                            </DialogActionsBar>
                        </Dialog>
                    )}


                    {this.state.showMessageDialog === true && (
                        <Dialog title={this.state.dialogTitle} onClose={this.toggleMessageDialog} width="400px">
                            {this.state.showSuccessImage === true && (
                                <div className="text-center">
                                <img className="successImg" src={SuccessImg} alt="Success"/>
                                </div>
                            )}
                
                            {this.state.showErrorImage === true && (
                                <div className="text-center">
                                <img className="successImg" src={ErrorImg} alt="Error Image"/>
                                </div>
                            )}
                
                            <p style={{ margin: '25px', textAlign: 'center' }}>{this.state.dialogMessage}</p>
                            <DialogActionsBar>
                                <button className="k-button modal-primary" onClick={this.toggleMessageDialog}>
                                    OK
                                </button>
                            </DialogActionsBar>
                        </Dialog>
                    )}

                    <Loader loading={this.state.loading} />
            </div>
        );
    }
}

export default ManagedServiceResourcePool;